import * as MutationTypes from './mutationTypes';

const authRequest = (state) => {
  state.status = 'loading';
};

const authSuccess = (state, { token, user }) => {
  state.status = 'success';
  state.token = token;
  state.user = user;
};

const authError = (state) => {
  state.status = 'error';
};

const logout = (state) => {
  state.status = '';
  state.token = '';
  state.user = '';
};


export const mutations = {
  [MutationTypes.AUTH_REQUEST]: authRequest,
  [MutationTypes.AUTH_SUCCESS]: authSuccess,
  [MutationTypes.AUTH_ERROR]: authError,
  [MutationTypes.LOGOUT]: logout,
};
